module.exports = __webpack_public_path__ + "media/images/placeholder-ce3b7d4fb60b804573a1e719bba5fbda.png";